import { render, staticRenderFns } from "./Year_book_class.vue?vue&type=template&id=8b1a2694&scoped=true"
import script from "./Year_book_class.vue?vue&type=script&lang=js"
export * from "./Year_book_class.vue?vue&type=script&lang=js"
import style0 from "./Year_book_class.vue?vue&type=style&index=0&id=8b1a2694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1a2694",
  null
  
)

export default component.exports